export const isDev = false;
export const isDebug = false;
